import { useEffect, useState, lazy, Suspense } from 'react';
import { Home } from './pages/Home';
import { Send } from './pages/Send';
import { Admin } from './pages/Admin';

// Phase B1 — POC fluid-sim chargé en lazy pour éviter de gonfler le bundle
// principal (Pavel engine ~15KB minified, shaders inline).
const FluidLab = lazy(() => import('./pages/FluidLab').then((m) => ({ default: m.FluidLab })));

type Route = '/' | '/send' | '/admin' | '/lab/fluid-sim' | '404';

function resolveRoute(pathname: string): Route {
  if (pathname === '/' || pathname === '') return '/';
  if (pathname === '/send' || pathname === '/send/') return '/send';
  if (pathname === '/admin' || pathname === '/admin/') return '/admin';
  if (pathname === '/lab/fluid-sim' || pathname === '/lab/fluid-sim/') return '/lab/fluid-sim';
  return '404';
}

export function App() {
  const [route, setRoute] = useState<Route>(() => resolveRoute(window.location.pathname));

  useEffect(() => {
    const onPop = () => setRoute(resolveRoute(window.location.pathname));
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  // Expose a simple navigate function on window for inline links without React Router
  useEffect(() => {
    (window as unknown as { __nav?: (to: string) => void }).__nav = (to: string) => {
      window.history.pushState({}, '', to);
      setRoute(resolveRoute(to));
    };
  }, []);

  if (route === '/') return <Home />;
  if (route === '/send') return <Send />;
  if (route === '/admin') return <Admin />;
  if (route === '/lab/fluid-sim') {
    return (
      <Suspense fallback={<div style={{ padding: 32, fontFamily: 'monospace' }}>loading fluid-sim…</div>}>
        <FluidLab />
      </Suspense>
    );
  }

  return (
    <main className="m-grid-center" style={{ height: '100vh' }}>
      <section style={{ textAlign: 'center' }}>
        <p className="m-label">404</p>
        <h1 style={{ fontSize: 24, fontWeight: 400, margin: '12px 0 24px' }}>page introuvable</h1>
        <a className="m-btn" href="/">retour accueil</a>
      </section>
    </main>
  );
}
